import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React, { memo } from "react";
import { momentDateToDB, momentTimeToDB } from "../../../utils/dateTime";

const LaporanInvestigasi = ({
  input,
  setInput,
  loading,
  refreshLokasi,
  readOnly = false,
}) => {
  const onChange = (value, reason) => {
    switch (reason) {
      case "clear":
      case "reset":
        break;
      case "input":
        setInput((prev) => ({
          ...prev,
          idLokasi: null,
          namaLokasi: value,
        }));
        break;
      case "selectOption":
        setInput((prev) => ({
          ...prev,
          idLokasi: value.id,
          namaLokasi: value.name,
        }));
        break;
    }
  };

  if (loading) {
    return (
      <>
        <Box sx={styles.container}>
          <Grid container spacing={3}>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
              </Stack>
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "3.2rem" }} />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={2}>
              <TextField
                variant="standard"
                label="Nomor Investigasi"
                value={input.noLapInevest}
                onChange={(e) =>
                  setInput((prev) => ({
                    ...prev,
                    noLapInevest: e.target.value,
                  }))
                }
                disabled={readOnly}
              />
              <FormControl>
                <Autocomplete
                  value={input.listUnitBisnis.find(
                    (opt) => opt.id == input.idUnitBisnis
                  )}
                  options={input.listUnitBisnis}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (!value) return;
                    setInput((prev) => ({ ...prev, idUnitBisnis: value.id }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Unit Bisnis" />
                  )}
                  disabled={readOnly}
                />
              </FormControl>
              <FormControl>
                <Autocomplete
                  value={input.listRegional.find(
                    (opt) => opt.id == input.idRegional
                  )}
                  options={input.listRegional}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (!value) return;
                    setInput((prev) => ({
                      ...prev,
                      idRegional: value.id,
                      idLokasi: 0,
                    }));
                    refreshLokasi(value.id);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Regional/Anak Perusahaan" />
                  )}
                  disabled={readOnly}
                />
              </FormControl>
              <FormControl>
                <Autocomplete
                  defaultValue={input.listLokasi.find(
                    (opt) => opt.id == input.idLokasi
                  )}
                  options={input.listLokasi}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value, reason) => onChange(value, reason)}
                  renderInput={(params) => (
                    <TextField {...params} label="Lokasi" />
                  )}
                  freeSolo
                  onInputChange={(e, value, reason) => onChange(value, reason)}
                  disabled={readOnly}
                />
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={2}>
              <TextField
                variant="standard"
                label="Judul Laporan"
                value={input.judulLaporan}
                onChange={(e) =>
                  setInput((prev) => ({
                    ...prev,
                    judulLaporan: e.target.value,
                  }))
                }
                disabled={readOnly}
              />
              <DesktopDatePicker
                label="Tanggal Kejadian"
                variant="standard"
                fullWidth
                inputFormat="DD-MMMM-YYYY"
                value={input.tglKejadian}
                onChange={(e) =>
                  setInput((prev) => ({
                    ...prev,
                    tglKejadian: momentDateToDB(e) + "T" + momentTimeToDB(e),
                  }))
                }
                maxDate={new Date()}
                renderInput={(params) => <TextField {...params} />}
                disableMaskedInput
                disabled={readOnly}
              />
              <TimePicker
                label="Waktu Kejadian"
                fullWidth
                variant="standard"
                ampm={false}
                inputFormat={"HH:mm"}
                value={input.waktuKejadian}
                onChange={(e) =>
                  setInput((prev) => ({
                    ...prev,
                    waktuKejadian: momentDateToDB(e) + "T" + momentTimeToDB(e),
                  }))
                }
                views={["hours", "minutes"]}
                renderInput={(params) => <TextField {...params} />}
                disableMaskedInput
                disabled={readOnly}
              />
              <DesktopDatePicker
                label="Tanggal Laporan"
                variant="standard"
                fullWidth
                inputFormat="DD-MMMM-YYYY"
                value={input.tglLaporan}
                onChange={(e) =>
                  setInput((prev) => ({
                    ...prev,
                    tglLaporan: momentDateToDB(e) + "T" + momentTimeToDB(e),
                  }))
                }
                maxDate={new Date()}
                renderInput={(params) => <TextField {...params} />}
                disableMaskedInput
                disabled={readOnly}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const styles = {
  container: {
    px: 5,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
};

export default memo(LaporanInvestigasi);
